export const PreviewCanvasNavbar = {
  extends: 'Navbar',
  gap: 'A2',
  round: 'radiusPill',
  padding: 'V Z',
  userSelect: 'none',
  theme: 'common-box',
  LogoDropdown: {},
  ComponentAddressBar: {
    flex: 1
  },
  Select: {
    padding: 'X Y2',
    margin: '-W -Y2 - auto',
    background: 'none',
    color: 'currentColor',
    width: 'D3',
    onChange: (ev, el, s, ctx) => {
      const value = ev.target.value
      if (value) {
        s.update({
          env: value
        })
      }
    },
    childrenAs: 'props',
    childProps: {
      tag: 'option',
      attr: {
        selected: (el, s) => el.node.value === s.action
      }
    },
    children: [
      {
        text: '{{ publish.envs.production | polyglot }}'
      },
      {
        text: '{{ publish.envs.development | polyglot }}'
      },
      {
        text: '{{ publish.envs.staging | polyglot }}'
      }
    ]
  },
  Meta: {
    extends: 'NavbarButtonSet',
    gap: 'W2',
    InNewTab: {
      icon: 'sf arrow up right',
      title: (el) => el.call('polyglot', 'members.sharingNavbar.newTab'),
      onClick: (ev, el, s) => {
        window.open(s.url)
      },
      '!url': {
        opacity: '.35',
        pointerEvents: 'none'
      }
    },
    Share: {
      title: (el) => el.call('polyglot', 'common.action.share'),
      icon: 'sf share',
      onClick: (ev, el, s) => {},
      Dropdown: {
        left: 'auto',
        right: '-A',
        ShareDropdown: {}
      },
      '!url': {
        opacity: '.35',
        pointerEvents: 'none'
      },
      extends: ['CanvasButton', 'IconButton', 'DropdownParentFocus']
    },
    Close: {
      title: (el) => el.call('polyglot', 'common.action.close'),
      icon: 'crossmark',
      onClick: (ev, el, s) => el.closeModal()
    }
  }
}
